export const currentModulesHandle = [
  {
    module: "leads",
    view: false,
    actions: {
      create: false,
      update: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "prospectos",
    view: false,
    actions: {},
    special_actions: {
      export: false,
    },
  },
  {
    module: "chats",
    view: false,
    actions: {},
    special_actions: {
      export: false,
      export_chat: false,
      delete_chat: false,
      human_atention: false,
      can_block_contact: false,
      create_chat: false,
      filters: false,
      can_view_budget_filter: false,
      can_view_follow_up_filter: false,
      can_view_notice_filter: false,
      can_view_generic_filter: false,
    },
  },
  {
    module: "horarios de atención",
    view: false,
    actions: {
      update: false,
    },
    special_actions: {},
  },
  {
    module: "contactos",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "productos",
    view: false,
    actions: {
      create: false,
      status: false,
      update: false,
      delete: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "perfiles",
    view: false,
    actions: {
      create: false,
      status: false,
      update: false,
      delete: false,
    },
    special_actions: {
      export: false,
      link_documents_rh: false,
    },
  },
  {
    module: "aprendizaje",
    view: false,
    actions: {
      create: false,
      delete: false,
    },
    special_actions: {},
  },
  {
    module: "pagos",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "tickets",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false
    },
    special_actions: {
      export: false
    },
  },
  {
    module: "dashboard leads",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false
    },
    special_actions: {
      export: false
    },
  },
  {
    module: "desarrollos",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "leads inmobiliaria",
    view: false,
    actions: {
      create: false,
      update: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "usuarios procesos",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false,
    },
    special_actions: {},
  },
  {
    module: "procesos",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "crm_products",
    view: false,
    actions: {
      create: false,
      status: false,
      update: false,
      delete: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "vendedores",
    view: false,
    actions: {
      create: false,
      status: false,
      update: false,
      delete: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "cotizaciones",
    view: false,
    actions: {},
    special_actions: {
      export: false,
    },
  },
  {
    module: "grupos",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false,
    },
    special_actions: {
      send_broadcast: false,
    },
  },
  {
    module: "citas",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false,
    },
    special_actions: {},
  },
  {
    module: "servicios",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false,
      status: false,
    },
    special_actions: {},
  },
  {
    module: "leads universidad",
    view: false,
    actions: {
      create: false,
      update: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    // Fase 2: Avisos de IA (insights proactivos). Lo lee la edge function ai-analyst.
    module: "inteligencia",
    view: false,
    actions: {},
    special_actions: {
      can_view_qa: false,          // Calidad de atención (QA de conversaciones)
      can_edit_qa_criteria: false, // El cliente define sus propios criterios de QA
    },
  },
  {
    // Canales de envío: correo SMTP y WhatsApp del proyecto (avisos y agente). Paso 17.
    module: "envios",
    view: false,
    actions: {},
    special_actions: {
      can_send_from_assistant: false, // El asistente prepara correos y el cliente los aprueba y envía
    },
  }
];
